import type { CdwColDef } from '../interfaces/cdw-col-def.interface';

export const selectionColumn: CdwColDef = {
  colId: 'selectCheckboxComponent', // Explicitly set colId to match cellRenderer
  headerName: 'Select',
  width: 50,
  pinned: 'left',
  headerComponent: 'multiSelectHeaderComponent',
  cellRenderer: 'selectCheckboxComponent',
  cellClass: 'ag-cell-center',
  headerClass: 'ag-header-center ag-header-hide-text',
  resizable: false,
  // System column: never user-draggable, and locked to the far left so no
  // other column can be dragged into its slot and a persisted column-layout
  // restore (applyColumnState) cannot reorder it.
  suppressMovable: true,
  lockPosition: 'left',
  suppressMenu: true,
  suppressColumnsToolPanel: true,
  lockVisible: true,
};
